import * as React from 'react';
import FAIcon from 'Shared/UI/IconFontAwesome';

const ICON = <FAIcon
               name="gift-card"
               style="duotone"
               className="fa-fw fa-7x"/>;

export default () => ICON;
